// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pS","category":"pT","tab":"pU","selected":"pV","isRental":"pW"};